<template>
    <div class="projects page">
        <h3 class="page-description">My projects consist of commercial experience as a web developer, ongoing self learning and side projects.</h3>
        <a href="https://www.supershuttle.co.nz/" class="project" target="_blank">
            <img src="../assets/images/projects/logo-ss-full.svg"/>
            <h4>Airport shuttle service</h4>
            <p>Responsible for building the entire website, public and corporate booking portals, real time vehicle monitoring systems.</p>
        </a>
        <a href="https://github.com/akash89/VueTube" class="project" target="_blank">
            <img class="img-vuetube" src="../assets/images/profile/logo-vuejs.svg"/>
            <h4>VueTube</h4>
            <p>Combined the Vue framework and YouTube API to search and watch videos.</p>
        </a>
        <a href="https://github.com/akash89/task-manager-api" class="project" target="_blank">
            <img class="img-mongpress" src="../assets/images/projects/logo-mongpress.svg"/>
            <h4>MongPress Task Manager</h4>
            <p>
                Used the node Express framework to build a REST API to implement CRUD against a MongoDB database. 
                Mongoose was used to model data. 
            </p>
        </a>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'Projects',
    methods: {
        ...mapActions(['showMenu', 'showFooter']),
    },
    created() {
        this.showMenu();
        this.showFooter();
    }
}
</script>

<style scoped>
p {
    font-family: lato-light;
    font-size: 0.9em;
    margin: 0;
}
.page-description {
    margin-bottom: 40px;
}
.projects {
    display: flex;
    flex-flow: column;
}
.project {
    display: flex;
    flex-direction: column;
    align-self: center;
    align-items: center;
    text-align: center;
    margin-bottom: 20px;
    padding: 20px;
    transition: all 0.5s;
}
.project:hover, .project:focus {
    background: #f7f7f7;
}
.project img {
    width: 200px;
    margin-bottom: 10px;
}
.project h4 {
    margin: 0;
    color: var(--light-blue);
}
.project p {
    color: var(--dark1);
}
img.img-vuetube {
    width: 80px;
}
img.img-mongpress {
    width: 50px;
}

@media (min-width: 410px) {
    .project {
        width: 260px;
    }
}
@media (min-width: 768px) {
    .project {
        width: 320px;
    }
    .project h4 {
        font-size: 1.2em;
    }
    .project p {
        font-size: 1.1em;
    }
}
</style>